import { render, staticRenderFns } from "./WebhookClient.vue?vue&type=template&id=22cf79ad&"
import script from "./WebhookClient.vue?vue&type=script&lang=js&"
export * from "./WebhookClient.vue?vue&type=script&lang=js&"
import style0 from "./WebhookClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports